export interface BankActionTypes {
  type: BankActions;
  payload?: any;
}

export enum BankActions {
  CREATE_BANK = "CREATE_BANK",
  GET_BANK_LIST = "GET_BANK_LIST",
  SET_BANK_LIST = "SET_BANK_LIST",
  SET_BANK_LIST_PAGE_COUNT = "SET_BANK_LIST_PAGE_COUNT",
  GET_BANK_DATA_BY_ID = "GET_BANK_DATA_BY_ID",
  SET_BANK_DATA_BY_ID = "SET_BANK_DATA_BY_ID",
  EDIT_BANK_DATA_BY_ID = "EDIT_BANK_DATA_BY_ID",
}
